const ROUND = 'fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

export const ECHASSIER_MARK =
  '<path d="M7.6 3.6h8.8l-.3 7.4H7.9z" fill="currentColor"/>' +
  '<path d="M8 12.6h8l-.15 2.7h-7.7z" fill="currentColor"/>' +
  `<path d="M3.2 16.4c2.6 2.4 15 2.4 17.6 0" ${ROUND} stroke-width="2"/>` +
  `<path d="M9.4 19.6 8.6 22.4M14.6 19.6l.8 2.8" ${ROUND} stroke-width="1.6"/>`;

export const GRAND_PAS_ICON =
  '<circle cx="10.6" cy="4.6" r="2.2" fill="currentColor"/>' +
  `<path d="M10.6 6.4 5 21M10.6 6.4l6.6 12.2" ${ROUND} stroke-width="2"/>` +
  `<path d="M3.4 11.4a9.4 9.4 0 0 1 14-3.2" ${ROUND} stroke-width="1.5" stroke-dasharray="1.6 2.2"/>` +
  `<path d="m15.2 6.2 2.6 2.2-3.2 1" ${ROUND} stroke-width="1.5"/>` +
  '<circle cx="18.4" cy="19.6" r="2.8" fill="none" stroke="currentColor" stroke-width="1.6"/>';
